// Links to Backbone Help Center (Salesforce) — still used for creatives / internal users
export enum HelpCenterLinks {
  EN = 'https://help.bkbn.com/s/?language=en_US',
  FR = 'https://help.bkbn.com/s/?language=fr',
  DE = 'https://help.bkbn.com/s/?language=de',
}

// Links to the new Client Help Center (Notiondesk) — clients only
export enum ClientHelpCenterLinks {
  EN = 'https://clients-help.bkbn.com/en',
  FR = 'https://clients-help.bkbn.com/fr',
  DE = 'https://clients-help.bkbn.com/de',
}
